// Shared Analyzer card constants. Extracted from AnalyzerDataCheck.jsx as
// part of the structural refactor -- values MUST match the original file
// exactly so the deployed Analyzer behavior is unchanged.

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const VERIFY_ENDPOINT = `${BACKEND_URL}/api/analyzer/verify-slip`;
export const EXPLAIN_ENDPOINT = `${BACKEND_URL}/api/analyzer/explain-score`;

export const MARKET_LABEL = {
  total_bases: "Total Bases",
  hits: "Hits",
  home_runs: "Home Runs",
  rbis: "RBIs",
  runs: "Runs",
  walks: "Walks",
  stolen_bases: "Stolen Bases",
  strikeouts: "Pitcher Strikeouts",
  pitcher_outs: "Pitcher Outs",
  pitcher_hits_allowed: "Pitcher Hits Allowed",
  pitcher_runs_allowed: "Pitcher Runs Allowed",
  pitcher_earned_runs: "Pitcher Earned Runs",
  pitcher_walks_allowed: "Pitcher Walks Allowed",
  moneyline: "Moneyline",
  run_line: "Run Line",
  spread: "Run Line",
  game_total: "Game Total",
  team_total: "Team Total",
};

export const MARKET_SHORT = {
  hits: "Hits",
  total_bases: "TB",
  home_runs: "HR",
  rbis: "RBI",
  runs: "R",
  walks: "BB",
  stolen_bases: "SB",
  strikeouts: "K",
  pitcher_outs: "Outs",
  pitcher_hits_allowed: "H Allowed",
  pitcher_runs_allowed: "R Allowed",
  pitcher_earned_runs: "ER",
  pitcher_walks_allowed: "BB Allowed",
  moneyline: "ML",
  run_line: "RL",
  spread: "RL",
  game_total: "Total",
  team_total: "TT",
};

export const LABEL_STYLE = {
  Strong:     { bg: "#059669", ring: "#065f46", text: "#ffffff" },
  Favorable:  { bg: "#0d9488", ring: "#115e59", text: "#ffffff" },
  Mixed:      { bg: "#ca8a04", ring: "#854d0e", text: "#ffffff" },
  Risky:      { bg: "#dc2626", ring: "#7f1d1d", text: "#ffffff" },
  Weak:       { bg: "#7f1d1d", ring: "#450a0a", text: "#ffffff" },
  "Insufficient Data": { bg: "#475569", ring: "#1e293b", text: "#ffffff" },
};

export const CONFIDENCE_TONE = {
  High:   { bg: "#059669", text: "#ffffff" },
  Medium: { bg: "#ca8a04", text: "#ffffff" },
  Low:    { bg: "#475569", text: "#ffffff" },
};
